var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3742 8.06758L7.62774 2.21222C7.57595 2.16758 7.50988 2.14258 7.44024 2.14258H5.85988C5.72774 2.14258 5.66702 2.30686 5.76702 2.39258L12.0206 7.82115H1.57059C1.49202 7.82115 1.42773 7.88544 1.42773 7.96401V9.03544C1.42773 9.11401 1.49202 9.17829 1.57059 9.17829H12.0188L5.76524 14.6069C5.66524 14.6944 5.72595 14.8569 5.85809 14.8569H7.49202C7.52595 14.8569 7.55988 14.8444 7.58488 14.8212L14.3742 8.93187C14.436 8.87811 14.4856 8.81171 14.5195 8.73716C14.5535 8.66261 14.5711 8.58165 14.5711 8.49972C14.5711 8.4178 14.5535 8.33683 14.5195 8.26228C14.4856 8.18773 14.436 8.12134 14.3742 8.06758Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.ac236d95280fe81aa4050776da901687.svg";
export { ForwardRef as ReactComponent };